<div class="urgency-driver">
  <div class="urgency-driver__content-left">
    <div class="urgency-driver__icon"></div>
    <span class="urgency-driver__description">{{ description }}</span>
  </div>
  <div class="urgency-driver__content-right" *ngIf="!limitedTimeOffer">
    <div class="urgency-driver__date" i18n>
      Expires on
      <div class="urgency-driver__break-line">
        {{ endDateInDays }}<sup>{{ endDateInDays | lxOrdinal }} </sup>{{ endDateMonthName }}
      </div>
    </div>
  </div>
</div>
